import { useEffect } from 'react';
import { trackAnonymousAmplitudeEvent } from '@/lib/analytics/amplitude/anonymousClient';
import { addAnalyticsEventListener } from '../utils/analyticsEventBus';

export const useAnonymousAmplitudeTracking = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    return addAnalyticsEventListener((eventName, properties) => {
      trackAnonymousAmplitudeEvent(eventName, properties);
    });
  }, [enabled]);
};
